<template>
  <time class="article__date text-primary-300 text-xs" :datetime="publishedDate">{{ articleDate }}</time>
</template>

<script>
import { computed, defineComponent } from '@nuxtjs/composition-api';
import { getDateWithTime, dayjs } from '~/modules/common/utils/dateUtils';

export default defineComponent({
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  setup({ article }) {
    // const publishedDate = computed(() => dayjs().format(article.dates?.updated));
    const publishedDate = computed(() => dayjs.utc(article.dates?.updated).tz('Europe/Istanbul').format());
    const articleDate = computed(() => getDateWithTime(article.dates?.updated));
    return { publishedDate, articleDate };
  },
});
</script>
